import { Link, Typography } from '@mui/material'
import React from 'react'
import Info from '../../../assets/info.svg'
import Sparkle from '../../../assets/sparkle.svg'
import styles from './FormFieldLabel.module.css'
import { CustomTooltip } from '../../CustomTooltip'

interface Props {
  text: string
  isAiGenerated?: boolean
  url?: string
  underlineLink?: boolean
  linkTitle?: string
  tooltipInfo?: React.ReactNode
  isLegacy?: boolean
}

export const FormFieldLabel = ({
  text,
  isAiGenerated = false,
  url = undefined,
  linkTitle = '',
  underlineLink = false,
  tooltipInfo,
  isLegacy = false,
}: Props) => {
  return (
    <div className={styles.labelContainer}>
      <Typography className={isLegacy ? styles.labelLegacy : styles.label}>{text}</Typography>
      {tooltipInfo && (
        <CustomTooltip
          title={tooltipInfo}
          placement="top"
          classes={{ tooltip: styles.tooltip }}>
          <img src={Info} />
        </CustomTooltip>
      )}
      {isAiGenerated && <img src={Sparkle} />}
      {url && (
        <Link
          href={url}
          underline={underlineLink ? 'always' : 'none'}
          className={styles.link}
          target="_blank">
          {linkTitle}
        </Link>
      )}
    </div>
  )
}
